import { FC } from 'react';
import { Modal } from '../../../components';
import { Fade, Typography, Box, ButtonGroup, Button } from '@mui/material';

interface IConfirmationModal {
  open: boolean;
  handleClose: (val?: string) => void;
}

export const ConfirmationModal: FC<IConfirmationModal> = ({ open, handleClose }) => {
  return (
    <Modal
      open={open}
      showClose={false}
      onClose={(e, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          handleClose();
        }
      }}
      maxWidth="xs"
    >
      <Fade in={open}>
        <div>
          <Typography align="center" paragraph>
            You've placed an item in your shopping cart that was previously ordered.
          </Typography>
          <Typography align="center" paragraph>
            Proceed?
          </Typography>
          <Box display="flex" justifyContent="center">
            <ButtonGroup>
              <Button variant="contained" onClick={() => handleClose('No')}>
                No
              </Button>
              <Button variant="contained" color="primary" onClick={() => handleClose('Yes')}>
                Yes
              </Button>
            </ButtonGroup>
          </Box>
        </div>
      </Fade>
    </Modal>
  );
};
